import { match } from 'ts-pattern';
import { IconInfoCircle, IconCircleCheck, IconX, IconAlertTriangle, IconLoader } from '@tabler/icons-react';
import ReactMarkdown from 'react-markdown';
import type { AIMessage } from '~/common/vm/protocol';
import { CollapsibleCard } from '../CollapsibleCard';
import { reactMarkdownComponents } from '~/components/common/ReactMarkDownComponents';

export function AIStatusCard({ message }: { message: Extract<AIMessage, { type: 'status' }> }) {
  const config = match(message.status)
    .with('success', () => ({
      icon: IconCircleCheck,
      iconColor: 'text-gray-500 dark:text-gray-400',
      title: 'Success',
    }))
    .with('error', () => ({
      icon: IconX,
      iconColor: 'text-gray-500 dark:text-gray-400',
      title: 'Error',
    }))
    .with('warning', () => ({
      icon: IconAlertTriangle,
      iconColor: 'text-gray-500 dark:text-gray-400',
      title: 'Warning',
    }))
    .with('generating', () => ({
      icon: IconLoader,
      iconColor: 'text-gray-500 dark:text-gray-400',
      title: 'Generating',
    }))
    .with('cancelled', () => ({
      icon: IconX,
      iconColor: 'text-gray-500 dark:text-gray-400',
      title: 'Cancelled',
    }))
    .with('info', () => ({
      icon: IconInfoCircle,
      iconColor: 'text-gray-500 dark:text-gray-400',
      title: 'Info',
    }))
    .exhaustive();

  return (
    <CollapsibleCard
      icon={config.icon}
      title={config.title}
      defaultExpanded={true}
      classNames={{
        icon: config.iconColor,
      }}
    >
      <div className="space-y-2">
        <div>
          <ReactMarkdown components={reactMarkdownComponents}>{message.content}</ReactMarkdown>
        </div>
      </div>
    </CollapsibleCard>
  );
}
